import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import { useShutdownPlanEndDateChange } from '../../api';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownPlanEndDateChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = {
          value: formValues[fieldNames.planEndDate]
            .clone()
            .set({ second: 0 })
            .utc()
            .format(),
        };
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  return (
    <Modal
      visible={type === modalTypes.changeShutdownPlanEndDate}
      onCancel={close}
      onOk={handleSubmit}
      title={`${
        shutdown.planEndDate ? 'Изменить' : 'Добавить'
      } плановую дату окончания`}
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.all}
      />
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.planEndDate}
          form={form}
          initialValue={shutdown.planEndDate}
          editMode
          shutdown={shutdown}
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_plan_end_date' })(
  ModalContainer
);

export default ChangeModal;
